<template>
  <div class="elevation-1 white pa-2" style="border-radius: 15px">
    <v-container>
      <v-row justify="center" align="center">
        <v-col
          cols="6"
          class="card d-flex flex-column align-center"
          @click="actionSelect(1)"
        >
          <div class="card-2 d-flex flex-column align-center justify-center">
            <img
              class="action-icon-1"
              :src="require('@/assets/icons/directions.svg')"
            />
          </div>
          <span
            class="secondary--text body-1 text-align-center font-weight-bold mt-4"
          >
            {{ this.$t("routes.directions_text") }}
          </span>
        </v-col>

        <v-col
          cols="6"
          class="card d-flex flex-column align-center"
          @click="actionSelect(2)"
        >
          <div class="card-2 d-flex flex-column align-center justify-center">
            <img
              class="action-icon-2"
              :src="require('@/assets/icons/start.svg')"
            />
          </div>
          <span
            class="secondary--text body-1 text-align-center font-weight-bold mt-4"
          >
            {{ this.$t("routes.start_text") }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {},

  methods: {
    actionSelect(action) {
      if (action == 1) this.$emit("startRoute", true);
      else {
        this.$emit("startRoute", false);
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  height: 200px !important;
  width: 100px !important;
}

.card-2 {
  height: 100% !important;
  width: 100% !important;
  background: rgba(40, 170, 229, 0.2);
  border-radius: 15px;
}

.card-2:hover {
  transition: 0.3s ease;
  background: rgba(40, 170, 229, 0.3);
}

.action-icon-1 {
  width: 60px;
}

.action-icon-2 {
  width: 52px;
}
</style>